import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets any previously saved payment state from the server.
   * @param {String} [newLoanHeader] - Optionally, the new loan header identifier.
   * @param {String} [newLoanId] - Optionally, the new loan identifier.
   * @param {String} [newLoanDueDate] - Optionally, the new loan due date.
   * @returns {Promise<{data: {route: String, state: {}}}>} Payment state.
   */
  async getPaymentState (newLoanHeader = undefined, newLoanId = undefined, newLoanDueDate = undefined) {
    Logger.info('Started get payment state query')
    return tmxApiCall('get', '/paymentCache', {
      params: {
        newLoanDueDate,
        newLoanHeader,
        newLoanId
      }
    })
  },

  /**
   * Saves any payment state on the server.
   * @param {String} loanId - The loan identifier associated with the payment data.
   * @param {String|Object} data - The payment user store data to save.
   */
  async postPaymentState (loanId, data) {
    Logger.info('Started post payment state request')
    return tmxApiCall('post', '/paymentCache', {
      loanId,
      data
    })
  },

  /**
   * Deletes any payment state saved on the server.
   */
  async deletePaymentState () {
    Logger.info('Started delete payment state request')
    return tmxApiCall('delete', '/paymentCache')
  }
}
